module.exports = __webpack_public_path__ + "static/two-user-avatar-icon-8d0c825c945589b98308f19e7f2de538.svg";